const translateError = (error) => {
  if (error === "Your email address is not verified.") {
    return "Su direccion de email no está verificada.";
  }
  return error;
}

export {
  translateError
}